import React, { useEffect, useState } from "react";
import { Modal, CloseButton } from "react-bootstrap";
import { FaSignInAlt } from "react-icons/fa";
import LoginButtons from "../social-wallet/loginButtons";
import { useAuth } from "../web3/context/AuthContext";

/**
 * Compact "Log in to pay" CTA shown in CheckoutPanel when the payer
 * picks the Horus Wallet source but isn't signed in yet.
 *
 * Clicking the button opens a Bootstrap modal that embeds the
 * existing <LoginButtons variant="pay" />. `variant="pay"` switches
 * the button layout from the header's row-of-icons to a stacked
 * full-width pill list with provider labels — purpose-built for a
 * checkout modal.
 *
 * The modal closes automatically once `AuthContext.isLoggedIn`
 * becomes true (via the effect below), so the payer returns to the
 * pay page in the logged-in state without an extra click.
 *
 * The site-wide post-login redirect to `/transferDashboard` is
 * suppressed for `/pay/*` paths inside loginButtons.js, so the URL
 * doesn't change after the modal closes.
 */
export function HorusLoginButton() {
  const { isLoggedIn } = useAuth();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (showModal && isLoggedIn) setShowModal(false);
  }, [showModal, isLoggedIn]);

  return (
    <>
      <button
        type="button"
        className="pay-horus-login-btn"
        onClick={() => setShowModal(true)}
      >
        <FaSignInAlt size={14} />
        Log in to pay with Horus Wallet
      </button>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="sm"
        centered
        className="pay-horus-login-modal"
      >
        <Modal.Body>
          <CloseButton
            onClick={() => setShowModal(false)}
            className="pay-horus-login-modal__close"
            aria-label="Close"
          />
          <div className="pay-horus-login-modal__header">
            <div className="pay-horus-login-modal__title">
              Log in to Horus Wallet
            </div>
            <div className="pay-horus-login-modal__sub">
              Choose how you want to sign in — we'll use your Horus balance
              to settle the payment.
            </div>
          </div>

          <LoginButtons variant="pay" />

          <div className="pay-horus-login-modal__footer">
            New here? Sign in with any option above — a Horus Wallet is
            auto-created on your first login.
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
